import { createFileRoute } from "@tanstack/react-router";
import AdminInnstillinger from "../../../../pages/AdminInnstillinger";

export const Route = createFileRoute("/_app/account/admin/innstillinger")({
	component: AdminInnstillinger,
});
